import axios from 'axios'
import { MFA_TRUSTED_DEVICE_STORAGE_KEY } from './mfa-session'

/**
 * @description service to login in bluesite
 * @param email
 * @param password
 */
const login = async (email: string, password: string) => {
  const apiUrl = `${process.env.REACT_APP_MAIN_API}/auth/login`
  const trustedDeviceToken = localStorage.getItem(MFA_TRUSTED_DEVICE_STORAGE_KEY)

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  }

  const response = await axios.post(
    apiUrl,
    {
      email,
      password,
      mfa_trusted_device_token: trustedDeviceToken || undefined,
    },
    config,
  )

  return response
}

export default login
